// Hero Brand Colors based on Hero Profilmanual Mai 2024
const almostBlack = '#505050';
const black = '#000000';
const semiBlack = '#333333';
const white = '#FFFFFF';
const darkGray = '#585858';
const gray = '#888888';
const lightGray = '#B8B8B8';
const semiGray = '#ccc';
const red = '#E03333';

// Hero Brand Primary Colors
const heroPurple = '#8B1C93'; // PANTONE 2070 C
const heroBeige = '#E2DBC8'; // PANTONE 7527 C

// Hero Brand Secondary Colors
const heroDarkBrown = '#531530'; // PANTONE 4695 C
const heroBlue = '#0093B1'; // PANTONE 7704 C
const heroGreen = '#1DAF8E'; // PANTONE 6144 C
const heroCoral = '#F08372'; // PANTONE 2434 C
const heroAccentDark = '#508f92';

// Additional colors for UI elements
const shadowColor = 'rgba(149, 157, 165, 0.2)';

// Hero brand opacity variants (based on heroDarkBrown #531530 = rgb(83, 21, 48))
const heroDarkBrownBorderLight = 'rgba(83, 21, 48, 0.1)'; // Very light borders/dividers
const heroDarkBrownBorder = 'rgba(83, 21, 48, 0.2)'; // Light borders
const heroDarkBrownBorderMedium = 'rgba(83, 21, 48, 0.4)'; // Medium borders
const heroDarkBrownPlaceholder = 'rgba(83, 21, 48, 0.6)'; // Placeholder text
const heroDarkBrownSecondary = 'rgba(83, 21, 48, 0.8)'; // Secondary text
const heroDarkBrownHover = 'rgba(83, 21, 48, 0.05)'; // Hover backgrounds
const heroPurple80 = 'rgba(139, 28, 147, 0.8)'; // heroPurple at 80% opacity
const heroBeigeBackground = 'rgba(226, 219, 200, 0.2)';

const elementHeight = 44;
const gridDefault = 10;

const LayoutHero = {
  elementHeight,

  grid: {
    default: gridDefault,
  },

  general: {
    logo: {
      resizeMode: 'contain',
    },

    poweredByLogo: {
      width: '100px',
      height: '20px',
      resizeMode: 'contain',
      alignSelf: 'center',
    },

    background: {
      position: 'absolute',
      left: 0,
      right: 0,
      top: 0,
      bottom: 0,
      width: null,
      height: null,
      resizeMode: 'cover',
    },

    h2: {
      fontSize: 20,
      backgroundColor: 'transparent',
    },

    h22: {
      fontSize: 18,
      backgroundColor: 'transparent',
    },

    h3: {
      fontSize: 16,
      backgroundColor: 'transparent',
    },

    p: {
      fontSize: 14,
      backgroundColor: 'transparent',
    },

    link: {
      backgroundColor: 'transparent',
      marginTop: gridDefault,
      marginBottom: gridDefault,
    },

    punchline: {
      fontSize: 20,
      opacity: 0.8,
      backgroundColor: 'transparent',
      paddingTop: 20,
      textAlign: 'center',
    },
  },

  color: {
    // Standard colors
    almostBlack,
    black,
    semiBlack,
    darkGray,
    gray,
    lightGray,
    semiGray,
    white,
    red,
    shadowColor,

    // Hero brand colors
    heroPurple,
    heroBeige,
    heroDarkBrown,
    heroBlue,
    heroGreen,
    heroCoral,
    heroAccentDark,
    heroPurple80,

    // Hero brand opacity variants
    heroDarkBrownBorderLight,
    heroDarkBrownBorder,
    heroDarkBrownBorderMedium,
    heroDarkBrownPlaceholder,
    heroDarkBrownSecondary,
    heroDarkBrownHover,
    heroBeigeBackground,

    // Legacy color mappings for compatibility
    sapphire: heroBlue, // Map to Hero Blue
    beach: heroGreen, // Map to Hero Green
    darkBeach: heroDarkBrown, // Map to Hero Dark Brown
    coral: heroCoral, // Keep Hero Coral
    twilight: heroPurple, // Map to Hero Purple
    twilightLight: heroPurple, // Map to Hero Purple
    blush: heroCoral, // Map to Hero Coral
    glass: heroBeige, // Map to Hero Beige
    sky: heroBeige, // Map to Hero Beige
  },

  form: {
    button: {
      width: 280,
      height: elementHeight,
      borderWidth: 0,
      justifyContent: 'center',
      alignSelf: 'center',
      borderRadius: 4,
    },

    buttonText: {
      fontSize: 16,
      lineHeight: 20,
      textAlign: 'center',
    },

    textInput: {
      fontSize: 14,
      height: elementHeight - 5,
      backgroundColor: white,
      textAlignVertical: 'center',
      borderRadius: 4,
    },
  },

  mainContainer: {
    flex: 1,
  },

  viewportWidth: () => '100%',
  viewportHeight: () => '100%',
  topMargin: 20,
  naviHeight: 44,
};

export default LayoutHero;